<script setup lang="ts">
import ButtonBase from './Base.vue';

const modelValue = defineModel<boolean>('modelValue', {
  default: false,
});

const toggle = (value: boolean) => {
  modelValue.value = value;
};
</script>

<template>
  <button
    :aria-label="
      modelValue
        ? $t('AriaLabel.MainMenu.Close')
        : $t('AriaLabel.MainMenu.Open')
    "
    data-component-name="Buttons.Burger"
  >
    <ButtonBase accent="black" fill="none" @click="toggle(!modelValue)">
      <div :class="{ cross: modelValue }" class="container">
        <span class="line" />
        <span class="line" />
        <span class="line" />
      </div>
    </ButtonBase>
  </button>
</template>

<style scoped lang="scss">
@use '_/mixins/size';
@use '_/fn';

[data-component-name='Buttons.Burger'] {
  [data-component-name='Buttons.Base'] {
    padding: 0;

    .container {
      position: relative;

      @include size.fixed-width(1.375rem);
      @include size.fixed-height(0.875rem);

      .line {
        display: block;
        height: 3px;
        width: 100%;
        background-color: fn.token('icon-primary');
        transition: all 0.15s ease;
        position: absolute;

        &:nth-child(1) {
          top: 0;
        }

        &:nth-child(2) {
          opacity: 1;
          top: 50%;
          transform: translate(0, -50%);
        }

        &:nth-child(3) {
          bottom: 0;
        }
      }

      &.cross {
        .line {
          &:nth-child(1) {
            top: 50%;
            transform: translate(0, -50%) rotate(-45deg);
          }

          &:nth-child(2) {
            opacity: 0;
          }

          &:nth-child(3) {
            bottom: 50%;
            transform: translate(0, 50%) rotate(45deg);
          }
        }
      }
    }
  }
}
</style>
